// extracted by mini-css-extract-plugin
export var dropdown = "_up-0";
export var imageWrapper = "_up-3";
export var itemNameContainer = "_up-1";
export var productImage = "_up-2";
export var spinnerWrapper = "_up-4";